// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ig_a bhh_ji","CommentListPlaceholder--Legacy":"ig_b bhh_ra bhh_wo"};